import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';

import { MultiUserPreferences } from 'app/features/settings/models';

import { multiUserPreferencesFeatureKey, MultiUserPreferencesState } from './multi-user-preferences.reducer';

export const selectPreferencesState = createFeatureSelector<MultiUserPreferencesState>(
    multiUserPreferencesFeatureKey,
);

export const selectMultiUserPreferences = createSelector(
    selectPreferencesState,
    (state) => state.multiUserPreferences,
);

export const selectMultiUserPreferencesIfLoaded = pipe(
    select(selectMultiUserPreferences),
    filter((preferences): preferences is MultiUserPreferences => !!preferences),
);

export const selectMultiUserRecentActivitiesIfLoaded = pipe(
    selectMultiUserPreferencesIfLoaded,
    map((preferences) => preferences?.recentActivityNumbers ?? []),
);

export const selectLastMultiUserRecentActivityNumberIfLoaded = createSelector(
    selectPreferencesState,
    (state) => state.multiUserPreferences?.recentActivityNumbers[0] ?? undefined,
);

export const selectMultiUserRecentEmployeeNumbersIfLoaded = pipe(
    selectMultiUserPreferencesIfLoaded,
    map((preferences) => preferences.recentEmployeeNumbers ?? []),
);

export const selectMultiUserRecentProductBoxNumberIfLoaded = pipe(
    selectMultiUserPreferencesIfLoaded,
    map((preferences) => preferences.recentProductBoxNumber ?? -1),
);
